import React from 'react'
import { twMerge } from 'tailwind-merge'
import { ReactComponent as Checkmark } from '../assets/icons/checkmark.svg'

interface SwitchProps {
  isOn: boolean
  toggle: () => void
  disabled?: boolean
}

const Switch = ({ isOn, toggle, disabled = false }: SwitchProps) => {
    return (
        <button
            className={twMerge(
                'w-[80px] h-[40px] md:w-[100px] md:h-[50px] flex-shrink-0 rounded-full transition duration-300 ',
                disabled && 'opacity-50',
            )}
            style={{ backgroundColor: isOn ? '#e6e6e6' : '#ccc' }}
            onClick={toggle}
            disabled={disabled}
        >
            <div
                className={twMerge(
                    'w-[40px] h-[40px] md:w-[50px] md:h-[50px] rounded-full transition duration-300 flex items-center justify-center',
                    isOn ? 'bg-purple translate-x-full' : 'bg-black',
                )}
            >
                {isOn ? (
                    <Checkmark className='w-[20px] stroke-white' />
                ) : (
                    <div style={{ width: '22px', height: '1px' }} className='bg-white' />
                )}
            </div>
        </button>
    )
}

export default Switch
